import {
  formatQueryForJsonApi,
  JsonApiQueryParameters,
  transformResponseFromJsonApi,
} from '@evolve/common-ui';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { dataFormatter, prepareHeaders } from 'evolve-ui';

export type IProfessionalSector = {
  id: string;
  name: string;
};

export type IProfessionalCategory = {
  id: string;
  name: string;
  portalId: string;
  professionalArea: {
    _id: string;
    name: string;
  };
};

export const officialProfessionalCategoriesApi = createApi({
  reducerPath: 'official-professional-categories',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.GATSBY_COMMUNICATIONS_API_URL}/official-professional-categories`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['OfficialProfessionalCategory'],
  endpoints: (builder) => ({
    getProfessionalCategories: builder.query<
      { values: IProfessionalSector[] },
      JsonApiQueryParameters
    >({
      providesTags: ['OfficialProfessionalCategory'],
      query: formatQueryForJsonApi,
      transformResponse: transformResponseFromJsonApi<IProfessionalSector>,
    }),
    getNewProfessionalCategories: builder.query<
      { values: IProfessionalSector[] },
      JsonApiQueryParameters
    >({
      query: (query) =>
        formatQueryForJsonApi(
          query,
          `${process.env.GATSBY_COMMUNICATIONS_API_URL}/official-professional-categories/categories`
        ),
      transformResponse: (response) => {
        const deserializedResponse = response as any;
        const formattedResponse: any =
          dataFormatter.deserialize(deserializedResponse);

        return {
          values:
            formattedResponse.professionalCategories as IProfessionalCategory[],
        };
      },
    }),
    getNewProfessionalSectors: builder.query<
      { values: IProfessionalSector[] },
      JsonApiQueryParameters
    >({
      query: (query) =>
        formatQueryForJsonApi(
          query,
          `${process.env.GATSBY_COMMUNICATIONS_API_URL}/official-professional-categories/sectors`
        ),
      transformResponse: (response) => {
        const deserializedResponse = response as any;
        const formattedResponse: any =
          dataFormatter.deserialize(deserializedResponse);

        return {
          values: formattedResponse.professionalAreas as IProfessionalSector[],
        };
      },
    }),
  }),
});

export const {
  useGetProfessionalCategoriesQuery,
  useGetNewProfessionalCategoriesQuery,
  useGetNewProfessionalSectorsQuery,
} = officialProfessionalCategoriesApi;
